/*
  Collection SEO content section.
  - Show More / Show Less toggle (collapsed state is CSS-only and gated on
    html.js, so no-JS visitors and crawlers always see the full copy).
  - Expand All / Collapse All for the <details> rows.
*/
if (!customElements.get('seo-collection-content')) {
  customElements.define(
    'seo-collection-content',
    class SeoCollectionContent extends HTMLElement {
      constructor() {
        super();
        this.onMore = this.onMore.bind(this);
        this.onExpand = this.onExpand.bind(this);
        this.onCollapse = this.onCollapse.bind(this);
      }

      connectedCallback() {
        this.moreButton = this.querySelector('[data-seo-more]');
        this.moreLabel = this.querySelector('[data-seo-more-label]');
        this.expandButton = this.querySelector('[data-seo-expand]');
        this.collapseButton = this.querySelector('[data-seo-collapse]');

        if (this.moreButton) this.moreButton.addEventListener('click', this.onMore);
        if (this.expandButton) this.expandButton.addEventListener('click', this.onExpand);
        if (this.collapseButton) this.collapseButton.addEventListener('click', this.onCollapse);

        // No Show More button configured: the section is always fully open.
        if (!this.hasAttribute('data-collapsible')) this.classList.add('is-expanded');
      }

      disconnectedCallback() {
        if (this.moreButton) this.moreButton.removeEventListener('click', this.onMore);
        if (this.expandButton) this.expandButton.removeEventListener('click', this.onExpand);
        if (this.collapseButton) this.collapseButton.removeEventListener('click', this.onCollapse);
      }

      get details() {
        return Array.from(this.querySelectorAll('details.collection-seo__item'));
      }

      onMore() {
        const expanded = this.classList.toggle('is-expanded');

        this.moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (this.moreLabel) {
          this.moreLabel.textContent = expanded
            ? this.moreButton.dataset.labelLess || 'Show Less'
            : this.moreButton.dataset.labelMore || 'Show More';
        }

        if (!expanded) {
          // Collapsing the block also closes every row, so reopening is clean.
          this.details.forEach((d) => {
            d.open = false;
          });

          const top = this.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }

      onExpand() {
        this.details.forEach((d) => {
          d.open = true;
        });
      }

      onCollapse() {
        this.details.forEach((d) => {
          d.open = false;
        });
      }
    }
  );
}
